import vid_size_1 from '../../assets/video/tim_size_giay_3.mp4'
import vid_size_2 from '../../assets/video/tim_size_giay_4.mp4'
import vid_size_3 from '../../assets/video/tim_size_giay_5.mp4'
import vid_size_4 from '../../assets/video/tim_size_giay_6.mp4'

export default {
    vid_size_1, vid_size_2, vid_size_3, vid_size_4
}